var AttachmentOpenAction;
(function (AttachmentOpenAction) {
    /// Take no action (e.g. completely unsupported)
    AttachmentOpenAction[AttachmentOpenAction["NoAction"] = 0] = "NoAction";
    /// View in side-by-side - see the AttachmentPreviewMethod enum for side-by-side rendering methods
    AttachmentOpenAction[AttachmentOpenAction["Preview"] = 1] = "Preview";
    /// Download
    AttachmentOpenAction[AttachmentOpenAction["Download"] = 2] = "Download";
    /// Open in a new tab
    AttachmentOpenAction[AttachmentOpenAction["OpenInNewTab"] = 3] = "OpenInNewTab";
})(AttachmentOpenAction || (AttachmentOpenAction = {}));
export default AttachmentOpenAction;
//# sourceMappingURL=AttachmentOpenAction.js.map